class RecipeGrid extends HTMLElement {
  constructor() {
    super();

    this.recipes = [];
    this.sectionContainer = null;
    this.gridContainer = null;
    this.recipeTemplate = null;
    this.levelTemplates = {};
  }

  connectedCallback() {
    this.sectionContainer = this.closest("section");
    this.gridContainer = this.querySelector("#recipe-grid");

    this.recipeTemplate =
      this.sectionContainer?.querySelector("#recipe-template") ||
      document.getElementById("recipe-template");

    this.levelTemplates = {
      facil:
        this.sectionContainer?.querySelector("#level-facil") ||
        document.getElementById("level-facil"),

      medio:
        this.sectionContainer?.querySelector("#level-medio") ||
        document.getElementById("level-medio"),

      dificil:
        this.sectionContainer?.querySelector("#level-dificil") ||
        document.getElementById("level-dificil"),
    };

    this.loadRecipes();
    this.renderRecipesFromUrl();
  }

  loadRecipes() {
    const sourceId = this.dataset.sourceId;
    const dataElement = sourceId
      ? document.getElementById(sourceId)
      : null;

    if (!dataElement) {
      console.error(
        "RecipeGrid: no se encontró el JSON de recetas.",
        sourceId
      );

      this.recipes = [];
      return;
    }

    try {
      const parsedData = JSON.parse(
        dataElement.textContent.trim() || "[]"
      );

      this.recipes = Array.isArray(parsedData)
        ? parsedData
        : [];
    } catch (error) {
      console.error(
        "RecipeGrid: no fue posible leer las recetas.",
        error
      );

      this.recipes = [];
    }
  }

  renderRecipesFromUrl() {
    const selectedFilters = this.getSelectedFiltersByGroup();

    const filteredRecipes = this.recipes.filter((recipe) => {
      return this.recipeMatchesFilters(
        recipe,
        selectedFilters
      );
    });

    this.renderRecipes(filteredRecipes);
  }

  getSelectedFiltersByGroup() {
    const params = new URLSearchParams(
      window.location.search
    );

    const selectedValues = params
      .getAll("tags-filter")
      .map((value) => String(value));

    const selectedFilters = {};

    if (!selectedValues.length) {
      return selectedFilters;
    }

    const filterInputs =
      this.sectionContainer?.querySelectorAll(
        'input[name="tags-filter"]'
      ) ||
      document.querySelectorAll(
        'input[name="tags-filter"]'
      );

    selectedValues.forEach((selectedValue) => {
      const matchingInput = Array.from(filterInputs).find(
        (input) =>
          String(input.value) === selectedValue
      );

      const group =
        matchingInput?.dataset.group || "other";

      if (!selectedFilters[group]) {
        selectedFilters[group] = [];
      }

      selectedFilters[group].push(selectedValue);
    });

    return selectedFilters;
  }

  recipeMatchesFilters(recipe, selectedFilters) {
    const filterGroups = Object.values(
      selectedFilters
    );

    if (!filterGroups.length) {
      return true;
    }

    const recipeTags = new Set(
      Array.isArray(recipe.tags)
        ? recipe.tags.map((tagId) => String(tagId))
        : []
    );

    /*
     * Dentro de un mismo grupo funciona como OR.
     *
     * Ejemplo:
     * Fácil O Medio.
     *
     * Entre grupos funciona como AND.
     *
     * Ejemplo:
     * Fácil Y Pastel Y Navidad.
     */
    return filterGroups.every((groupValues) => {
      return groupValues.some((tagId) => {
        return recipeTags.has(String(tagId));
      });
    });
  }

  normalizeLevel(level) {
    return String(level || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  }

  renderRecipes(recipes) {
    if (!this.gridContainer) {
      return;
    }

    if (!this.recipeTemplate) {
      console.error(
        "RecipeGrid: no se encontró #recipe-template."
      );

      this.renderErrorMessage(
        "No fue posible mostrar las recetas."
      );

      return;
    }

    this.gridContainer.innerHTML = "";

    if (!recipes.length) {
      this.renderEmptyMessage();
      return;
    }

    recipes.forEach((recipe) => {
      const fragment =
        this.recipeTemplate.content.cloneNode(true);

      const link = fragment.querySelector("a");
      const image = fragment.querySelector("img");
      const picture = fragment.querySelector("picture");
      const title = fragment.querySelector(
        ".recipe-title"
      );
      const time = fragment.querySelector(
        ".recipe-time"
      );
      const levelContainer = fragment.querySelector(
        ".recipe-level"
      );

      if (link) {
        link.href = recipe.url || "#";
      }

      if (title) {
        title.textContent = recipe.title || "";
      }

      if (time) {
        time.textContent =
          recipe.cooking_time || "";
      }

      if (image && recipe.image) {
        image.src = recipe.image;
        image.alt = recipe.title || "Receta";
        image.loading = "lazy";
      } else if (picture) {
        picture.remove();
      }

      const levelKey = this.normalizeLevel(
        recipe.level
      );

      const levelTemplate =
        this.levelTemplates[levelKey];

      if (levelContainer && levelTemplate) {
        const levelFragment =
          levelTemplate.content.cloneNode(true);

        levelContainer.appendChild(levelFragment);
      }

      this.gridContainer.appendChild(fragment);
    });
  }

  renderEmptyMessage() {
    this.gridContainer.innerHTML = `
      <p class="
        tw-col-span-full
        tw-w-full
        tw-text-center
        tw-text-lg
        tw-py-12
      ">
        No se encontraron recetas con los filtros seleccionados.
      </p>
    `;
  }

  renderErrorMessage(message) {
    this.gridContainer.innerHTML = `
      <p class="
        tw-col-span-full
        tw-w-full
        tw-text-center
        tw-text-lg
        tw-py-12
      ">
        ${message}
      </p>
    `;
  }
}

if (!customElements.get("recipe-grid")) {
  customElements.define(
    "recipe-grid",
    RecipeGrid
  );
}